// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_jve","cls2":"TransactionalPricingModal-cls2_5FR TransactionalPricingModal-cls1_jve"};